// Load css file
//const loadCss = (fileName) => {
  //return new Promise((resolve, reject) => {
    //const link = document.createElement('link');
    //const fileId = `${fileName.toUpperCase()?.replace('-', '')}CSS`;
    //const mainPath = document.getElementById('MainCssPath').href;
    //link.onload = resolve;
    //link.onerror = reject;
    //link.id = fileId;
    //link.rel = 'stylesheet';
    //link.type = 'text/css';
    //link.href = mainPath.includes('?v')
      //? mainPath.split('?v')[0]?.replace('/assets/theme.scss.css', `/assets/${fileName}.css?v=12`)
      //: mainPath.replace('/assets/theme.scss.css', `/assets/${fileName}.css?v=12`);
    //link.media = 'all';
    //if (!document.getElementById(fileId)) {
      //document.head.appendChild(link);
    //}
  //});
//};
//// Load js file
//const loadScript = (fileName) => {
  //return new Promise((resolve, reject) => {
    //const script = document.createElement('script');
    //const fileId = `${fileName.toUpperCase()?.replace('-', '')}JS`;
    //const mainPath = document.getElementById('MainJsPath').src;
    //script.onload = resolve;
    //script.onerror = reject;
    //script.async = true;
    //script.id = fileId;
    //script.type = 'text/javascript';
    //script.src = mainPath.includes('?v')
      //? mainPath.split('?v')[0]?.replace('/assets/theme.js', `/assets/${fileName}.js`)
      //: mainPath.replace('/assets/theme.js', `/assets/${fileName}.js`);
    //if (!document.getElementById(fileId)) {
      //document.head.appendChild(script);
    //}
  //});
//};
// class MainDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.trigger = this.querySelector('.drawer__trigger');
//     this.drawer = this.querySelector('.drawer');
//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDrawer());
//     this.querySelectorAll('.drawer-close').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
//     if (this.trigger) {
//       this.trigger.addEventListener('click', () => this.openDrawer());
//     }

//     this.setFocus = debounce((event) => {
//       trapFocus(this, this.querySelector('.drawer__container'));
//     }, 300);
//   }

//   openDrawer() {
//     this.setFocus();
//     this.drawer.classList.add('drawer--active');
//     document.body.classList.add('drawer--open');
//   }

//   closeDrawer() {
//     this.drawer.classList.remove('drawer--active');
//     setTimeout(() => {
//       document.body.classList.remove('drawer--open');
//     }, 500);
//     document.activeElement.blur();
//   }
// }
// customElements.define('main-drawer', MainDrawer);
// console.log('collection.js')
class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', () => {
        this.loadAssets()});
    }
  }

  initTabs() {
    const tabs = this.querySelectorAll('.drawer__tab');
    const tabContents = this.querySelectorAll('.drawer__tab-content');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;
        
        tabs.forEach(t => t.classList.remove('drawer__tab--active'));
        tabContents.forEach(content => {
          content.classList.remove('drawer__tab-content--active');
          content.style.display = 'none';
        });
        
        tab.classList.add('drawer__tab--active');
        const targetContent = this.querySelector(`[data-tab-content="${targetTab}"]`);
        if (targetContent) {
          targetContent.classList.add('drawer__tab-content--active');
          targetContent.style.display = 'block';
        }
      });
    });
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
          this.initTabs();
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();
  }
}
customElements.define('facet-drawer', FacetDrawer);

// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Details animation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.classList.remove('details--active');
  summaryElement.setAttribute('aria-expanded', false);
  setTimeout(() => {
    openDetailsElement.removeAttribute('open');
  }, 500);
  if (summaryElement.classList.contains('mmenu__hamburger') && document.body.classList.contains('mmenu--open')) {
    document.body.classList.remove('mmenu--open');
  }
  summaryElement.focus();
}
/*
class Accordion {
  constructor(el) {
    this.details = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.details__content');
    this.contentInner = el.querySelector('.details__content-inner');

    this.summary.addEventListener('click', (event) => this.onClick(event));
    this.details.addEventListener('keyup', onKeyUpEscape);
    window.addEventListener('DOMContentLoaded', this.mobileOnlyDetails());
  }

  onClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute('aria-expanded', !this.details.hasAttribute('open'));

    if (this.details.hasAttribute('open')) {
      this.collapse();
    } else {
      this.expand();
    }

    if (this.summary.classList.contains('mmenu__hamburger')) {
      document.body.classList.toggle('mmenu--open');
    }
  }

  collapse() {
    this.content.style.removeProperty('height');
    this.details.classList.remove('details--active');
    setTimeout(() => {
      this.details.removeAttribute('open');
    }, 250);
  }

  expand() {
      //this.content.style.height = '300px'
    this.details.setAttribute('open', '');

      console.log('this.contentInner.offsetHeight')
      console.log(this.contentInner.offsetHeight)
      this.content.style.height = this.contentInner.offsetHeight + 16 + 'px'
    setTimeout(() => {
      this.details.classList.add('details--active');
    }, 150);
  }

  mobileOnlyDetails() {
    if (this.details.classList.contains('mobile--only')) {
      if (window.innerWidth < 769) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }
}
document.querySelectorAll('[id^="Details-"]').forEach((el) => {
  new Accordion(el);
});
*/